import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { DropDown, DropDownMenu, Tag } from "@src/components/atoms";
import AdditionalFilterTagTray from "./AdditionalFilterTagTray";
import AdditionalFiltersMenu from "./AdditionalFiltersMenu";
import AppUtils from "@src/utils/appUtils";
import { useDCContext } from "@src/context/dcContext";
import { useManagerContext } from "../../../context/managerContext";

const FeedbackFilters = (props) => {
  const { filters, vehicleTypes, setFilters, updateResults, routes } = props;
  const { getDynamicReplacement } = useDCContext();
  const { profile } = useManagerContext();
  const { behaviours, customer } = profile;
  const isAviation = customer.industry === "aviation";

  const monthsSinceLaunchDateIncludeCurrentMonth =
    AppUtils.getMonthsSinceLaunchDate(customer.contractStartDate).map((d) =>
      moment.utc(d),
    );

  const dropDownOptions = [
    { text: "All behaviours", value: "ALL" },
    ...behaviours.map((bvr) => ({
      text: bvr.behaviourName,
      value: bvr.behaviourKey,
    })),
  ];

  const updateFilters = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    updateResults(newFilters);
  };

  const fromDates = [];
  const toDates = [];

  monthsSinceLaunchDateIncludeCurrentMonth.forEach((month) => {
    if (!filters?.startMonth || month > filters?.startMonth) {
      toDates.push({
        text: moment.utc(month).format("MMMM YYYY"),
        value: month.valueOf(),
      });
    }
    if (!filters?.endMonth || month < filters?.endMonth) {
      fromDates.push({
        text: moment.utc(month).format("MMMM YYYY"),
        value: month.valueOf(),
      });
    }
  });

  const removeAdditionalFilter = (key) => {
    const newAdditionalFilters = { ...filters.additionalFilters };
    if (key === "voyage") {
      newAdditionalFilters.origin.value = "ALL";
      newAdditionalFilters.destination.value = "ALL";
    } else if (key === "vehicle") {
      newAdditionalFilters.vehicle = [];
    } else {
      newAdditionalFilters[key].value = "ALL";
    }
    updateFilters("additionalFilters", newAdditionalFilters);
  };

  //dynamin content
  const fromText = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__date_from",
  );
  const toText = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__date_to",
  );
  const addButtonText = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__add_filter_button",
    {},
    "",
    true,
  );

  return (
    <div className="pt-5 px-7">
      <div className="flex flex-wrap">
        <div className="flex flex-col md:flex-row flex-wrap md:mr-3">
          <div className="mr-3 mb-3 flex items-center">
            <span className="mr-3">{fromText}</span>
            <DropDown
              options={fromDates}
              value={filters?.startMonth || fromDates[0].value}
              className="h-12"
              onChange={(e) => updateFilters("startMonth", e)}
            />
          </div>
          <div className="mb-3 flex items-center">
            <span className="mr-3">{toText}</span>
            <DropDown
              options={toDates}
              value={filters?.endMonth || toDates[toDates.length - 1].value}
              className="h-12"
              onChange={(e) => updateFilters("endMonth", e)}
            />
          </div>
        </div>
        <div className="mb-3 flex flex-row items-center">
          <span className="mr-3">Behaviours</span>
          <DropDown
            options={dropDownOptions}
            value={filters.behaviour}
            className="h-12"
            onChange={(e) => updateFilters("behaviour", e)}
          />
        </div>
        <div className="grow order-last items center mb-3">
          <DropDownMenu text={addButtonText} iconName="plus">
            <AdditionalFiltersMenu
              vehicleTypes={vehicleTypes}
              routes={routes}
              additionalFilters={filters.additionalFilters}
              updateFilters={updateFilters}
              isAviation={isAviation}
              getDynamicReplacement={getDynamicReplacement}
            />
          </DropDownMenu>
        </div>
        <AdditionalFilterTagTray
          additionalFilters={filters.additionalFilters}
          isAviation={isAviation}
          closeFunc={removeAdditionalFilter}
          getDynamicReplacement={getDynamicReplacement}
        />
      </div>
    </div>
  );
};

export const FeedbackFiltersControls = {};
FeedbackFilters.propTypes = AppUtils.getPropTypeFromControls(
  FeedbackFiltersControls,
);

export default FeedbackFilters;
